const diffMinutes = (dt2: Date, dt1: Date) => {
  const diff = (dt2.getTime() - dt1.getTime()) / 1_000 / 60;
  return Math.abs(diff);
};
export default function timeDifference(start: string, end: string) {
  const m1 = new Date(start);
  const m2 = end ? new Date(end) : new Date();
  const m3 = diffMinutes(m1, m2);

  const d = Math.floor(m3 / 1_440);
  const h = Math.floor((m3 - d * 1_440) / 60);
  let m = m3 % 60;

  if (d === 0 && h === 0 && m < 1) {
    return "1 minute";
  }

  m = Math.round(m3 % 60);

  let duration = "";
  if (d > 0 && h > 0 && m > 0) {
    duration = `${d} days`;
  } else if (h > 0 && m > 0 && d <= 0) {
    duration = `${h} hours`;
  } else if (m > 0 && h <= 0 && d <= 0) {
    duration = `${m} minutes`;
  } else if (d > 0 && h > 0 && m <= 0) {
    duration = `${d} days`;
  } else if (d > 0 && h <= 0 && m > 0) {
    duration = `${d} days`;
  } else if (d > 0 && h <= 0 && m <= 0) {
    duration = `${d} days`;
  } else if (d <= 0 && h > 0 && m <= 0) {
    duration = `${h} hours`;
  } else if (d === 0 && h === 0 && m === 0) {
    duration = "-";
  } else {
    duration = `${d} days, ${h} hours, ${m} minutes`;
  }
  return duration;
}

export const getDuration = (utcTime: string) => {
  const now = new Date();
  const utc = new Date(now.getTime() + now.getTimezoneOffset() * 60_000);
  return timeDifference(utcTime, utc.toString());
};
